<template>
  <footer class="footer_container">
    <div style='padding: 10px 20px 20px 20px;'>
      <a class="heading_7" href="tel:1600-1600">고객센터 1600-1600</a>
      <p class="body_11" style="marginBottom:4px">SK스피드메이트(주) | 대표이사: 이환용</p>
      <p class="body_11 f_gray_4">주소 : 경기도 수원시 장안구 경수대로976번길 19(송죽동)</p>
      <p class="body_11 f_gray_4">통신판매업신고 : 제2024-수원장안-0677호
        <a class="body_11" href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7888703184&apv_perm_no=">사업자 정보 확인</a>
      </p>
      <p class="body_11">Copyright ⓒ SK Speedmate Co. Ltd. All Rights Reserved</p>
      <div class="footer_term_wrapper">
        <a class="heading_12" @click="handleTermModalOpen(50)">개인정보처리방침</a>
        <a class="body_11 f_gray_4" @click="handleTermModalOpen(60)">이용약관</a>
      </div>
    </div>
    <Modal
      v-if="!!termItem"
      :isVisible="!!termItem"
      :title="termItem.title"
      :onClose="handleTermModalClose"
      :hasPadding="true"
      :content="termItem.content">
    </Modal>
  </footer>
</template>

<script>
import Vue from 'vue'
import Modal from '@/components/ai/AiModal.vue'

export default {
	mounted() {
    this.getTermsFooterList();
	},
	components: {
    Modal
  }
  ,data() {
		return {
      isTerm1:{},
      isTerm2:{},
			termItem:undefined,
      termList: [{}],
    }
  },
  methods: {
    async getTermsFooterList(){
			var $this = this;
			Vue.httpClient
			.post('/m/ai/term/list/footer', {})
			.then(response => {
				if(response.data.status=='200'){
					var result = response.data.result
          result.map((item)=>{

            if(item.termType === 50){
              $this.isTerm1.title = item.title
              $this.isTerm1.content = item.contents
            }
            if(item.termType === 60){
              $this.isTerm2.title = item.title
              $this.isTerm2.content = item.contents
            }
          })
				}
			})
		},
    handleTermModalOpen(termType){
      if(termType === 50){
        this.termItem = this.isTerm1
      } else if (termType === 60){
        this.termItem = this.isTerm2
      } else {

      }
    },
		handleTermModalClose() {
			this.termItem = undefined
		},

	},

}
</script>

<style scoped>

.footer_container {
  background-color: var(--gray-scale-11);
  letter-spacing: 0 !important;
}

.footer_container > div > a {
  color: var(--gray-scale-2) !important;
  margin-bottom: 24px;
}

.footer_container > div > p> a {
  color: var(--gray-scale-2) !important;
  text-decoration: underline;
  margin-left: 2px;
}

.footer_term_wrapper {
  display: flex;
  align-items: center;
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid var(--gray-scale-9);
  gap: 16px;
}

.footer_term_wrapper > a:hover {
  color: var(--gray-scale-2);
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiFooter.vue